const STORE_ROCKET_WIDGET_SRC = 'https://cdn.storerocket.io/js/widget.js';
const urlParams = new URLSearchParams(window.location.search);
let preSelectedStoreFlowStarted = false;
window.ElevarDataLayer = window.ElevarDataLayer || [];
let storeAcuityLocale;

function injectStoreRocketWidget() {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;
  script.src = STORE_ROCKET_WIDGET_SRC;
  const firstScript = document.getElementsByTagName('script')[0];
  firstScript.parentNode.insertBefore(script, firstScript);
}

function handleStoreRocketCTA(element) {
  if (!element.href.startsWith('https://{')) return;

  // Replace single quotes ➜ double quotes so JSON.parse works
  const schedulerData = element.href.replace('https://', '').replace(/'/g, '"');

  if (element.hasAttribute('data-event-listener-attached')) return;
  element.setAttribute('data-event-listener-attached', 'true');

  element.addEventListener('click', (e) => {
    e.preventDefault();
    try {
      const data = JSON.parse(schedulerData);
      // React app rendering developer conditional control
      window.reactAppSchedulerFlow = window.reactAppSchedulerFlow ?? true;  // AB test control = true
      const reactAppSchedulerFlow = window.reactAppSchedulerFlow;
      if (reactAppSchedulerFlow) {
        window.bookAcuityFitting(data, element, false)
        return;
      }
      storeAcuityLocale = data.locale;
      const isOverlaySelected = element.classList.contains('storerocket-overlay-details-custom-ctas-item');
      const parentElement = isOverlaySelected
        ? element.parentElement.parentElement.parentElement
        : element.parentElement.parentElement;
      const baseSelector = isOverlaySelected ? '.storerocket-overlay-details' : '.storerocket-result';
      storeName = parentElement.querySelector(`${baseSelector}-name`).textContent.trim();
      loggedIn = parseFloat(document.querySelector('#acuity-app').dataset.loggedIn);
      window.ElevarDataLayer.push({
        event: 'dl_begin_fitting',
        locationName: storeName,
        loggedIn: loggedIn,
      });
      const fullUrl = new URL(data.link);
      const params = new URLSearchParams(fullUrl.search);

      const owner = params.get('owner');
      const calendarID = params.get('calendarID');
      const location = params.get('location');
      const ref = 'embedded_csp';

      let iframeSrc = `https://app.acuityscheduling.com/schedule.php?owner=${encodeURIComponent(owner)}&ref=${encodeURIComponent(ref)}`;
      if (location) iframeSrc += `&location=${encodeURIComponent(location)}`;
      if (calendarID) iframeSrc += `&calendarID=${encodeURIComponent(calendarID)}`;

      const container = document.querySelector('.acuity-embed-container');
      if (container) {
        container.innerHTML = `
          <iframe
            src="${iframeSrc}"
            title="Schedule Appointment"
            width="100%"
            height="800"
            frameborder="0">
          </iframe>`;

        if (!document.querySelector('#acuity-embed-script')) {
          const embed = document.createElement('script');
          embed.id = 'acuity-embed-script';
          embed.src = 'https://embed.acuityscheduling.com/js/embed.js';
          embed.type = 'text/javascript';
          document.body.appendChild(embed);
        }
      }
      const selectedStoreElement = document.querySelector('#selected-store');
      if (selectedStoreElement) {
        // TO DO: if going with iframe embed solution for Acuity schduler - replace the copy below with localized text
        selectedStoreElement.innerHTML = `Schedule Your Fitting at ${storeName}`;
        const iframe = container.querySelector('iframe');
        if (iframe) {
          // wait to scroll down to iframe until after it has been loaded
          iframe.addEventListener('load', () => {
            selectedStoreElement.scrollIntoView({ behavior: 'smooth' });
          });
        }
      }
    } catch (err) {
      console.error('StoreRocket handler: failed to parse JSON from href', err);
    }
  });

  window.ctaTranslatorAndFilterApply(element);

  /* If URL param ?startFittingFlow=true is present, kick off the flow once after the first search results appear. */
  const startFittingFlow = urlParams.get('startFittingFlow');
  if (startFittingFlow === 'true' && !preSelectedStoreFlowStarted) {
    waitForElement('.storerocket-result-button', () => {
      window.startFittingFlow();
      preSelectedStoreFlowStarted = true;
    });
  }
}

function dropdownFilterOptionsTranslationsHandler(el) {
  const urlParamFilters = urlParams.get('filteredStores');
  window.filterOptionsTranslateAndPreSelect(el, urlParamFilters);
}

function storeCardFilterTypeTranslationHelper(el) {
  window.storeCardLocalization(el);
}

function waitForElement(selector, callback, timeout = 5000) {
  const obs = new MutationObserver(() => {
    if (document.querySelector(selector)) {
      obs.disconnect();
      callback();
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });
  setTimeout(() => obs.disconnect(), timeout);
}

document.addEventListener('DOMContentLoaded', () => {
  injectStoreRocketWidget();

  elementReady('.storerocket-overlay-details-custom-ctas-item', false, handleStoreRocketCTA).then(handleStoreRocketCTA);
  elementReady('.storerocket-result-button',                  false, handleStoreRocketCTA).then(handleStoreRocketCTA);

  elementReady('.storerocket-overlay-filters-list',     false, dropdownFilterOptionsTranslationsHandler);
  elementReady('.storerocket-result-item-filter-name',  false, storeCardFilterTypeTranslationHelper);
  elementReady('.storerocket-overlay-filters-item',     false, storeCardFilterTypeTranslationHelper);
});

window.addEventListener('message', function(event) {
  // Check if the message is from Acuity Custom Conversion Tracking
  if (event.data && event.data.event === 'acuityConversion') {
    window.ElevarDataLayer.push({
      event: 'dl_appointment_booking',
      locationName: storeName,
      loggedIn: loggedIn,
      fittingExperience: event.data.appointmentType,
      appointmentDate: event.data.appointmentDate,
      currencyCode: Shopify.currency.active,
      ecommerce: {
        purchase: {
          actionField: {
            id: event.data.bookingID,
            affiliation: 'PXG',
            revenue: '0',
            tax: '0',
            shipping: '0',
            coupon: null,
            newCustomer: loggedIn,
            shippingMethod: 'NA',
            paymentMethod: 'NA',
          },
          products: [
            {
              name: event.data.appointmentType,
              id: event.data.bookingID,
              price: '0.00',
              variant: null,
              brand: 'PXG',
              quantity: 1,
              category: 'Fitting',
              coupon: null,
              dimension3: 'Web',
              dimension4: storeAcuityLocale,
              appointmentDate: event.data.appointmentDate
            }
          ]
        }
      }
    });
  }
});
